import { createContext, useContext } from 'react';
import Keycloak from 'keycloak-js';
import { getRealm } from '../ui_refresh/utils/getRealm';
import MessageBus from '@restore/messagebus';

const realm = getRealm(window.location.host);

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: realm || 'master',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

const AuthContext = createContext<Keycloak>(keycloak);

export interface AuthProviderProps {
  children: React.ReactNode;
  realm?: string;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const messageBus = new MessageBus();
  const keycloak = useContext(AuthContext);

  messageBus.subscribe('keycloakLogin', () => {
    keycloak.login();
  });

  return <AuthContext.Provider value={keycloak}>{children}</AuthContext.Provider>;
};

export default AuthContext;
